export const environment = {
  production: true,

  APP_ENV: 'production',
  title: 'SurplusTek',
  apiUrl:"https://backend.surplustek.in",

  product_image_limit: 5,
  product_attachment_limit: 5,
  productPerPage_limit: 20,

  REGISTRATION_RECORD_LIMIT:"500"
};
